import { DefaultActions, Separator, Showing, Total, Search, Wrapper } from '@/components/Grid/components/header/Heading';
import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { useSiteStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'
import useFilters from './useFilters'

function SiteGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
    events: useEvents(),
  })

  return <DefaultGrid
    heading={<Wrapper>
      <Search />
      <Separator />
      <Total />
      <Showing />
      <Separator />
      <DefaultActions />
    </Wrapper>}
  />
}

export default function SiteGridLayout() {
  return <GridProvider store={useSiteStore()}>
    <SiteGrid />
  </GridProvider>
}
